module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/communication/chat-check-080cd3789dbf950892e4ff7969782752.svg";